import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-primary-50 dark:bg-slate-950">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300 dark:text-slate-600">404</h1>
        <p className="text-gray-500 dark:text-slate-400 mt-4 mb-8">Seite nicht gefunden</p>
        <Link to="/" className="text-primary-600 dark:text-primary-400 hover:underline font-medium">
          Zum Dashboard
        </Link>
      </div>
    </div>
  );
}
